import { IFluidObject } from '@fluidframework/core-interfaces';
import { Pairing } from '../MessageTypes';
import { getHostSideNotificationService } from '../Proxies/NotificationServiceProxy';
import { getHostSideShareService } from '../Proxies/ShareServiceProxy';
import { getHostSideTelemetryConfig } from '../Proxies/TelemetryConfigProxy';
import { getHostSideHostContext } from '../Proxies/HostContextProxy';
import { PostMessageHandlerFactory, PostMessageSender } from '../Shared/PostMessage';
import { getHostSideStylingProvider } from '../Proxies/StylingProviderProxy';
import { getHostSidePeopleService } from '../Proxies/PeopleServiceProxy';
import { getHostSidePresenceColorProvider } from '../Proxies/PresenceColorProviderProxy';

export function getScopeProxyInfo(
  sender: PostMessageSender,
  scope: IFluidObject
): {
  sendableScope: Pairing<IFluidObject>;
  scopeHandlerFactories: PostMessageHandlerFactory[];
  dispose: () => void;
} {
  const scopeHandlerFactories: PostMessageHandlerFactory[] = [];

  const hostSideNotificationService = getHostSideNotificationService(scope);
  if (hostSideNotificationService.scopeHandler) {
    scopeHandlerFactories.push(hostSideNotificationService.scopeHandler);
  }
  const hostSideShareService = getHostSideShareService(scope);
  if (hostSideShareService.scopeHandler) {
    scopeHandlerFactories.push(hostSideShareService.scopeHandler);
  }
  const hostSidePeopleService = getHostSidePeopleService(scope);
  if (hostSidePeopleService.scopeHandler) {
    scopeHandlerFactories.push(hostSidePeopleService.scopeHandler);
  }
  const hostSidePresenceColorProvider = getHostSidePresenceColorProvider(scope);
  if (hostSidePresenceColorProvider.scopeHandler) {
    scopeHandlerFactories.push(hostSidePresenceColorProvider.scopeHandler);
  }

  const TelemetryConfig = getHostSideTelemetryConfig(scope);
  const HostContext = getHostSideHostContext(scope);
  const StylingProviderProxy = getHostSideStylingProvider(scope, sender);

  const sendableScope: Pairing<IFluidObject> = {
    NotificationServicePromise: hostSideNotificationService.scopePairingValue,
    ShareServicePromise: hostSideShareService.scopePairingValue,
    PeopleServicePromise: hostSidePeopleService.scopePairingValue,
    PresenceColorProvider: hostSidePresenceColorProvider.scopePairingValue,
    TelemetryConfig: TelemetryConfig as any, // TODO: Need better type instead of IFluidObject,
    HostContext: HostContext as any, // TODO: Need better type instead of IFluidObject,
    StylingProvider: StylingProviderProxy?.component as any // TODO: Need better type instead of IFluidObject,
  };

  return {
    sendableScope,
    scopeHandlerFactories,
    dispose: () => StylingProviderProxy?.dispose && StylingProviderProxy.dispose()
  };
}
